/* eslint-disable react/prefer-stateless-function */
import React from 'react';
import { FormControl } from 'react-bootstrap';
import classNames from 'classnames';

interface Props {
  year: number | undefined;
  placeholder: string;
  setYear: (year: number | undefined) => void;
  hasError: boolean;
  disabled: boolean;
}

export class YearInput extends React.Component<Props> {
  render() {
    const { year, placeholder, setYear, hasError, disabled } = this.props;
    return (
      <div className="year-input">
        <FormControl
          id={`form-control-${
            placeholder === 'Max Year' ? 'max-year' : 'min-year'
          }`}
          className={
            hasError ? classNames('yearInput', 'has-error') : 'yearInput'
          }
          type="text"
          value={year}
          placeholder={placeholder}
          disabled={disabled}
          onChange={event => {
            if ((event.target as HTMLInputElement).value) {
              setYear(parseInt((event.target as HTMLInputElement).value, 10));
            } else {
              setYear(undefined);
            }
          }}
        />
      </div>
    );
  }
}
